import { BasketOpenContext } from "context/orderFormContexts/BasketOpenContext"
import { useContext } from "react"

export function useBasketOpen() {
  const { basketOpen, setBasketOpen } = useContext(BasketOpenContext)
  return { basketOpen, setBasketOpen }
}
